export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const STAGE = import.meta.env.VITE_STAGE;
export const REGION = import.meta.env.VITE_REGION;
export const PRODUCT_WEB_SOCKET_URL = import.meta.env
  .VITE_PRODUCTS_WEBSOCKET_API_URL;
